var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetry(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M14.9765 8.93965C15.6851 11.691 14.2733 14.6132 11.5703 15.7224C8.61691 16.9345 5.24055 15.5229 4.02893 12.5698C2.81729 9.61661 4.22919 6.23992 7.18267 5.02785C8.92917 4.31111 10.8233 4.51118 12.3322 5.40707C12.6515 5.5966 13.0639 5.49145 13.2535 5.1722C13.443 4.85295 13.3379 4.4405 13.0186 4.25096C11.1622 3.14879 8.82579 2.90021 6.67221 3.78401C3.03193 5.27794 1.29152 9.43991 2.78504 13.0801C4.27858 16.7204 8.44048 18.4602 12.0808 16.9663C15.2057 15.6839 16.9306 12.4355 16.4117 9.2387L17.1036 9.92721C17.3667 10.1891 17.7924 10.1881 18.0543 9.92488C18.3162 9.6617 18.3151 9.23605 18.0519 8.97417L16.0129 6.94509C15.7497 6.6832 15.324 6.68425 15.0622 6.94742L13.0328 8.98674C12.7709 9.24992 12.772 9.67557 13.0352 9.93745C13.2983 10.1993 13.724 10.1983 13.9859 9.93512L14.9765 8.93965Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.73f0ac2a.svg";
export { ForwardRef as ReactComponent };